<template>
  <div class="form-card-forms">
    <div class="form-group">
      <p v-if="!visaCountry" class="detail">How much would you like to send?</p>
      <div class="row">
        <div class="col-lg-6">
          <div class="form-group">
            <label for>
              You Send
              <span class="required">*</span>
            </label>
            <div class="input-with-flag">
              <div class="flag">
                <img src="static/img/flags/my.png" alt />
                <h3>MYR</h3>
              </div>
              <input type="text" class="form-control txt-input" id="name" v-only-numeric-rate:decimal
                @keyup="onPAmountChange" name="PCurrency" placeholder="0.00" autocomplete="off"
                v-model="vModel.PCurrency" data-vv-as="Send amount" v-validate="'required:51'"
                :class="{'input': true, 'is-danger': errors.has('PCurrency') }" />
            </div>
            <div v-show="errors.has('PCurrency')" class="help is-danger">{{ errors.first('PCurrency') }}</div>
          </div>
        </div>
        <div class="col-lg-6">
          <div class="form-group">
            <label for>
              Receiver Gets
              <span class="required">*</span>
            </label>
            <div class="input-with-flag">
              <div class="flag">
                <img :src="'/static/img/flags/'+vModel.RecipientDetail.FlagCode+'.png'" alt />
                <h3>{{vModel.PayCurrency}}</h3>
              </div>
              <input type="text" v-only-numeric-rate:decimal v-validate="'required'" name="SCurrency"
                data-vv-as="Payout amount" :class="{'input': true, 'is-danger': errors.has('SCurrency') }"
                class="form-control txt-input" placeholder="0.00" v-model="vModel.SCurrency"
                @keyup="onSAmountChange" />
            </div>
            <div v-show="errors.has('SCurrency')" class="help is-danger">{{ errors.first('SCurrency') }}</div>
          </div>
        </div>
      </div>
      <!-- eo row -->
    </div>
    <!-- eo form group -->
    <div class="exchange-notice text-center">
      <h4>The current exchange rate is</h4>
      <h4 class="detail">1 MYR = {{vModel.ExchangeRate}} {{vModel.PayCurrency}}</h4>
    </div>
  </div>
</template>
<script>
  import TransactionService from "../../services/transaction";
  export default {
    name: "ExchangeCalculator",
    inject: ["$validator"],
    props: ["vModel", "visaCountry"],
    methods: {
      onPAmountChange: function () { //send amount change
        setTimeout(() => {
          if (!this.vModel.PCurrency) {
             this.vModel.SCurrency = undefined;
             this.vModel.PCurrency = undefined;
             this.vModel.DepositedAmount = undefined;
            return;
          }

          let amount =
            parseFloat(this.vModel.InitialExchangeRate) *
            parseFloat(this.vModel.PCurrency);
          amount = this.onToFixed(amount, 4);
          amount = this.onToFixed(amount, 2);
          this.vModel.IsLocalCurrencyKeyedIn = true;
          this.vModel.SCurrency = isNaN(amount)
            ? ""
            : parseFloat(amount).toFixed(2);
         // this.vModel.PCurrency = parseFloat(this.vModel.PCurrency).toFixed(2);
          this.vModel.DepositedAmount = (
            parseFloat(this.vModel.PCurrency) +
            parseFloat(this.vModel.TransferFee)
          ).toFixed(2);

          //Check Special Rate
          this.checkSpecialRateForUser();
        }, 3000);
      },
      onSAmountChange: function () { //payout amount change
        setTimeout(() => {
          if (!this.vModel.SCurrency) {
             this.vModel.PCurrency = undefined;
             this.vModel.SCurrency = undefined;
             this.vModel.DepositedAmount = undefined;
            return;
          }

          let amount =
            parseFloat(this.vModel.SCurrency) /
            parseFloat(this.vModel.InitialExchangeRate);
          amount = this.onToFixed(amount, 4);
          amount = this.onToFixed(amount, 2);
          this.vModel.PCurrency = isNaN(amount)
            ? ""
            : parseFloat(amount).toFixed(2);
          this.vModel.IsLocalCurrencyKeyedIn = false;
         // this.vModel.SCurrency = parseFloat(this.vModel.SCurrency).toFixed(2);
          this.vModel.DepositedAmount = (
            parseFloat(this.vModel.PCurrency) +
            parseFloat(this.vModel.TransferFee)
          ).toFixed(2);

          //Check Special Rate          
          this.checkSpecialRateForUser();
        }, 3000);
      },
      onToFixed: function (number, fractionSize) {
        return +(
          Math.round(+(number.toString() + "e" + fractionSize)).toString() +
          "e" +
          -fractionSize
        );
      },

      checkSpecialRateForUser: function () {
        if (this.vModel.PayoutModeId != 97 
        && this.vModel.PayoutModeId != 98 
        && this.vModel.PayoutModeId !=101 
        && this.vModel.PayoutModeId != 102
        && this.vModel.SCurrency 
        && this.vModel.PCurrency
        ) {
          setTimeout(() => {
            
            TransactionService.getSpecialRateDetail({
              RecipientId: this.vModel.RecipientDetail.Id,
              PaymentModeId: this.vModel.PayoutModeId,
              SendAmount: parseFloat(this.vModel.PCurrency).toFixed(2),
              RequestIdentifier: this.vModel.RequestIdentifier,
            }).then((res) => {

              if (res.body && res.body.SpecialRateId) {
                this.vModel.SpecialRateDetail.SpecialRateId = res.body.SpecialRateId;
                this.vModel.SpecialRateDetail.SendAmount = res.body.SendAmount.toFixed(2);
                this.vModel.SpecialRateDetail.PayAmount = res.body.PayAmount.toFixed(2);
                this.vModel.SpecialRateDetail.SpecialRate = res.body.SpecialRate.toFixed(4);
                this.vModel.SpecialRateDetail.DefaultRate = res.body.DefaultRate.toFixed(4);
                this.vModel.SpecialRateDetail.CurrencyCode = res.body.CurrencyCode;

              } else {
                this.vModel.ExchangeRate = this.vModel.InitialExchangeRate;
                this.vModel.SpecialRateDetail = res.body;
                this.vModel.SpecialRateId = null;
                this.vModel.LastSpecialRateDialogClickedButton = null;
              }

              if (
                this.vModel.SpecialRateDetail.SpecialRateId &&
                this.vModel.SpecialRateDetail.SpecialRateId ==
                this.vModel.SpecialRateId &&
                this.vModel.LastSpecialRateDialogClickedButton == "YES"
              ) {
                this.vModel.SCurrency = this.vModel.SpecialRateDetail.PayAmount;
                this.vModel.PCurrency = this.vModel.SpecialRateDetail.SendAmount;
                this.vModel.ExchangeRate = this.vModel.SpecialRateDetail.SpecialRate;
                this.vModel.SpecialRateId = this.vModel.SpecialRateDetail.SpecialRateId;
                this.vModel.DefaultRate = this.vModel.SpecialRateDetail.DefaultRate;
                this.vModel.ShowSpecialRateDialog = false;
              } else if (
                this.vModel.SpecialRateDetail.SpecialRateId &&
                this.vModel.SpecialRateDetail.SpecialRateId ==
                this.vModel.SpecialRateId &&
                this.vModel.LastSpecialRateDialogClickedButton == "NO"
              ) {
                this.vModel.ShowSpecialRateDialog = false;
              } else if (this.vModel.SpecialRateDetail.SpecialRateId &&
                !this.vModel.LastSpecialRateDialogClickedButton) {
                this.vModel.ShowSpecialRateDialog = true;
              }

              console.log(this.vModel);
            });
          }, 500);
        }
      },

    },
  };
</script>